//Include Both Helper File with needed methods
import { getFirebaseBackend } from '../../../helpers/firebase_helper'

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
  forgotPasswordLoading,
  forgotPasswordError,
  otpSentSuccess,
  resetForgotPassword,
} from './reducer'
import { Axios } from 'api/axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const userPayload = {
      mobile_number: user?.mobile_number,
      password: user?.password,
      remember_me: user?.remember_me || false,
    }

    const userLogin = await Axios.post(
      'users/login/',
      JSON.stringify(userPayload),
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    console.log('User login response:', userLogin)

    if (userLogin.status === 200 && userLogin?.data?.data) {
      console.log('User login data:', userLogin.data)
      localStorage.setItem('authUser', JSON.stringify(userLogin?.data.data))
      dispatch(loginSuccess(userLogin))
      return userLogin.data
    } else {
      console.log('in else: ', userLogin)
      dispatch(apiError('Login failed. Please check your credentials.'))
      return Promise.reject('Login failed')
    }
  } catch (error: any) {
    console.log('Error response:::::', error)

    let backendMsg = 'Login failed. Please try again.';

    // Check if it's a network error (no response from server)
    if (!error.response) {
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        backendMsg = 'Request timeout. Please check your connection and try again.';
      } else if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
        backendMsg = 'Network error. Please check your internet connection or contact support if the problem persists.';
      } else {
        backendMsg = 'Unable to connect to server. Please check your connection or contact support.';
      }
      dispatch(apiError(backendMsg));
      return Promise.reject(backendMsg);
    }

    // Handle HTTP response errors
    const status = error.response?.status;
    const resData = error.response?.data;

    // Handle different HTTP status codes
    if (status >= 500) {
      // Server errors (500, 502, 503, etc.)
      backendMsg = 'Server error. Please try again later or contact support.';
    } else if (status === 401 || status === 403) {
      // Authentication/Authorization errors
      if (resData && typeof resData === 'object') {
        if (resData.message === 'Invalid username' || resData.error === 'Invalid username') {
          backendMsg = 'Incorrect mobile number.';
        } else if (resData.message === 'Invalid password' || resData.error === 'Invalid password') {
          backendMsg = 'Incorrect password.';
        } else if (resData.message?.includes('Mobile number') || resData.error?.includes('Mobile number')) {
          backendMsg = resData.error || resData.message || 'Incorrect mobile number.';
        } else {
          backendMsg = resData.error || resData.message || resData.detail || 'Invalid credentials. Please check your mobile number and password.';
        }
      } else {
        backendMsg = 'Invalid credentials. Please check your mobile number and password.';
      }
    } else if (status === 400) {
      // Bad request - validation errors
      if (resData && typeof resData === 'object') {
        backendMsg = resData.error || resData.message || resData.detail || 'Invalid request. Please check your input.';
      } else {
        backendMsg = 'Invalid request. Please check your input.';
      }
    } else if (status === 404) {
      backendMsg = 'Login endpoint not found. Please contact support.';
    } else if (status === 429) {
      backendMsg = 'Too many login attempts. Please try again later.';
    } else if (resData && typeof resData === 'object') {
      // Try to extract error message from response
      backendMsg = resData.error || resData.message || resData.detail || backendMsg;
    }

    dispatch(apiError(backendMsg));
    return Promise.reject(backendMsg);
  }
}

export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem('authUser')
    if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
      let fireBaseBackend = getFirebaseBackend()
      const response = fireBaseBackend.logout
      dispatch(logoutUserSuccess(response))
    } else {
      dispatch(logoutUserSuccess(true))
    }
  } catch (error) {
    dispatch(apiError(error))
  }
}

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    try {
      let response

      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        const fireBaseBackend = getFirebaseBackend()
        response = fireBaseBackend.socialLoginUser(type)
      }
      //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response
      if (socialdata) {
        localStorage.setItem('authUser', JSON.stringify(socialdata))
        dispatch(loginSuccess(socialdata))
        history('/dashboard')
      }

    } catch (error) {
      dispatch(apiError(error))
    }
  }

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag())
    return response
  } catch (error) {
    dispatch(apiError(error))
  }
}

export const fetchUserDetails = createAsyncThunk(
  'Login/fetchUserDetails',
  async (_, { getState }) => {
    const state: any = getState();
    const userId = state.Login.user?.user_id; // Adjust if your user object uses a different key
    if (!userId) throw new Error("User ID not found in state");
    const response = await Axios.get(`users/users/${userId}/`);
    return response.data;
  }
);

//*// User permissions fetch and stored in LS 
export const fetchLatestPermissions = createAsyncThunk(
  "Login/fetchLatestPermissions",
  async (_, { getState, rejectWithValue, dispatch }) => {
    try {

      const state: any = getState();
      // console.log("state:", state);
      const userId = state.Login.user?.user_id || JSON.parse(localStorage?.getItem('authUser') as string)?.user_id;
      // console.log("userId:", userId);

      if (!userId) {
        return rejectWithValue("User ID not found in state");
      }

      let response = await Axios.get(`/users/users/${userId}/`);

      // console.log("res.data.permissions", response);

      let res = response.data;

      if (res.data.permissions) {
        localStorage.setItem("userPermissions", JSON.stringify(res.data.permissions));
      }
      return res.data.permissions;
    } catch (error: any) {
      const errorResponse = error.response?.data;
      const status = error.response?.status;
      const errorMessage = errorResponse?.message || errorResponse?.detail;

      // Check if the error response indicates invalid or expired token (401)
      if (status === 401 || errorMessage === "Invalid or expired token.") {
        toast.error("Your session has expired. Please login again.");
        // Logout the user immediately
        await dispatch(logoutUser());
        window.location.href = "/login";
        return rejectWithValue("Invalid or expired token");
      }

      // Check if the error response indicates user is inactive or deleted
      if (errorResponse?.detail === "User inactive or deleted") {
        toast.error("Your account has been deactivated. Please contact support.");
        // Logout the user immediately
        await dispatch(logoutUser());
        window.location.href = "/login";
        return rejectWithValue("User inactive or deleted");
      }
      
      return rejectWithValue(errorResponse || "Failed to fetch latest permissions");
    }
  }
);

// export const fetchLatestPermissions = createAsyncThunk(
//   "Login/fetchLatestPermissions",
//   async (_, { getState, rejectWithValue, dispatch }) => {
//     try {
//       const state: any = getState();
//       const userId = state.Login.user?.user?.user_id
//         || JSON.parse(localStorage.getItem('authUser') || '{}')?.user?.user_id;

//       if (!userId) return rejectWithValue("User ID not found in state");

//       const res = await Axios.get(`api/permissions/user/${userId}`);

//       // Check if user is inactive or deleted
//       if (res.data?.detail === "User inactive or deleted") {
//         // Logout the user immediately
//         await dispatch(logoutUser());
//         window.location.href = "/login";
//         return rejectWithValue("User inactive or deleted");
//       }

//       // The Node.js backend returns { user_id, apps_permissions } directly
//       const permissions = res.data?.apps_permissions || [];
//       const userType = res.data?.data?.user_type_name

//       // Update localStorage and Redux in one step
//       const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
//       // console.log("authUser", authUser);

//       if (authUser.user) {
//         authUser.user.user_type = userType;
//       }
//       authUser.permissions = permissions;
//       //*// Set the new userType(If changed)
//       const updatedAuthUser = { ...authUser, user_type: userType, permissions };
//       localStorage.setItem("authUser", JSON.stringify(updatedAuthUser));
//       localStorage.setItem("userPermissions", JSON.stringify(permissions));

//       dispatch(loginSuccess(updatedAuthUser));

//       return permissions;
//     } catch (error: any) {
//       // Check if the error response indicates user is inactive or deleted
//       if (error.response?.data?.detail === "User inactive or deleted") {
//         // Logout the user immediately
//         await dispatch(logoutUser());
//         window.location.href = "/login";
//         return rejectWithValue("User inactive or deleted");
//       }
//       return rejectWithValue(error.response?.data || "Failed to fetch latest permissions");
//     }
//   }
// );

export const fetchLatestPermissionsLogin = createAsyncThunk(
  "Login/fetchLatestPermissions",
  async (userId: string, { getState, rejectWithValue }) => {
    try {
      const res = await Axios.get(`/users/users/${userId}/`);
      if (res.data.permissions) {
        localStorage.setItem("userPermissions", JSON.stringify(res.data.permissions));
      }
      return res.data.permissions;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to fetch latest permissions");
    }
  }
);

// Forgot Password Thunks
export const sendForgotPasswordOTP = createAsyncThunk(
  "Login/sendForgotPasswordOTP",
  async (email: string, { dispatch, rejectWithValue }) => {
    try {
      dispatch(forgotPasswordLoading(true));
      const payload = { email };

      const response = await Axios.post(
        "users/forgot-password/",
        JSON.stringify(payload),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200 || response.status === 201) {
        dispatch(otpSentSuccess());
        return { success: true, message: "OTP sent to your email successfully" };
      } else {
        const errorMsg = response.data?.error || response.data?.message || "Unable to send OTP, please try again later";
        dispatch(forgotPasswordError(errorMsg));
        return rejectWithValue(errorMsg);
      }
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Something went wrong. Please try again later.";
      dispatch(forgotPasswordError(errorMsg));
      return rejectWithValue(errorMsg);
    }
  }
);

export const verifyOTPAndResetPassword = createAsyncThunk(
  "Login/verifyOTPAndResetPassword",
  async (
    { email, otp, newPassword }: { email: string; otp: string; newPassword: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(forgotPasswordLoading(true));
      const payload = {
        email,
        otp,
        new_password: newPassword,
      };

      const response = await Axios.post(
        "users/verify-otp/",
        JSON.stringify(payload),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200 || response.status === 201) {
        dispatch(resetForgotPassword());
        return { success: true, message: "Password reset successfully" };
      } else {
        const errorMsg = response.data?.error || response.data?.message || "Failed to reset password";
        dispatch(forgotPasswordError(errorMsg));
        return rejectWithValue(errorMsg);
      }
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Something went wrong. Please try again later.";
      dispatch(forgotPasswordError(errorMsg));
      return rejectWithValue(errorMsg);
    }
  }
);


